export const showEvent = args => `Show event triggered with (${args})`;
export const hideEvent = args => `Show event triggered with (${args})`;

export const applyMiddleware = (events, evtFn, nextFn) => (id, ...args) => {
  events.push(evtFn(...args));
  return nextFn(id, ...args);
};
